import React, { useRef, useEffect, useState } from "react";
import { menuItems } from "@/constant/data";
import SidebarLogo from "./Logo";
import Navmenu from "./Navmenu";

const Sidebar = () => {
  const [menuHover, setMenuHover] = useState(false);

  return (
    <div
      className={`sidebar-wrapper w-[248px] bg-white dark:bg-metaxseed-black overflow-y-auto 
      ${menuHover ? "sidebar-hovered" : ""}
      
      `}
      onMouseEnter={() => {
        setMenuHover(true);
      }}
      onMouseLeave={() => {
        setMenuHover(false);
      }}
      data-testid="sidebar"
    >
      <div className="flex flex-row justify-center items-center px-6 mt-4">
        <SidebarLogo zeroPadding={true} menuHover={menuHover} />
      </div>

      <div
        className="sidebar-menu px-4 h-[calc(100%-80px)]"
      >
        <Navmenu menus={menuItems} />
      </div>
    </div>
  );
};

export default Sidebar;
